"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyQueryFilters = exports.applyQueryFilters = void 0;
const react_1 = require("react");
const query_core_1 = require("@sierralabs/query-core");
const SearchFieldsQueryBuilderPlugin_1 = require("../plugins/SearchFieldsQueryBuilderPlugin");
/**
 * Add filters to expressionMap.
 * @param expressionMap The QueryExpressionMap to apply filters.
 * @param options The filter options.
 * @returns The updated QueryExpressionMap.
 */
function applyQueryFilters(expressionMap, options) {
    var _a;
    const { paginated } = options;
    const merge = { queryType: expressionMap.queryType };
    if (paginated) {
        const limit = Math.min(100, (_a = options.limit) !== null && _a !== void 0 ? _a : 100);
        const offset = (options.page || 0) * limit;
        merge.limit = limit;
        merge.offset = offset;
    }
    if (options.order) {
        merge.orderBys = [
            { propertyPath: options.order, order: options.direction || 'ASC' }
        ];
    }
    // merge to properly save arrays (e.g. orderBys)
    const config = (0, query_core_1.mergeExpressionMaps)(expressionMap, merge);
    // get all pluginConditions with updates (e.g. search filters)
    config.pluginConditions = getPluginConditions(expressionMap.pluginConditions || [], options);
    return config;
}
exports.applyQueryFilters = applyQueryFilters;
function getPluginConditions(pluginConditions, options) {
    const { search, searchPaths } = options;
    // check if expressionMap has a SearchFieldsQueryBuilderPlugin
    // condition already configured and update it with search value
    const has = { searchFilter: false };
    const conditions = (pluginConditions || []).map(pluginConfigs => {
        return pluginConfigs.map(condition => {
            // add search filters for SearchFieldsQueryBuilderPlugin
            if (condition.pluginType === SearchFieldsQueryBuilderPlugin_1.SearchFieldsQueryBuilderPlugin.type &&
                condition.conditionType === 'SearchFilter') {
                has.searchFilter = true;
                const params = Object.assign(Object.assign({}, condition.params), { search });
                if (searchPaths) {
                    params.paths = searchPaths;
                }
                // create copy to avoid mutating data
                return Object.assign(Object.assign({}, condition), { params });
            }
            // -- add other checks here if needed --
            return condition;
        });
    });
    // add search condition if it does not exist yet
    if (!has.searchFilter && search && searchPaths && searchPaths.length > 0) {
        conditions.push([
            {
                pluginType: SearchFieldsQueryBuilderPlugin_1.SearchFieldsQueryBuilderPlugin.type,
                conditionType: 'SearchFilter',
                params: { search, paths: searchPaths }
            }
        ]);
    }
    return conditions;
}
function useApplyQueryFilters(expressionMap, options) {
    return (0, react_1.useMemo)(() => {
        return applyQueryFilters(expressionMap, options);
    }, [expressionMap, options]);
}
exports.useApplyQueryFilters = useApplyQueryFilters;
//# sourceMappingURL=useApplyQueryFilters.js.map